<template>
  <div class="lineItem d-flex justify-content-between py-2">
    <div class="d-flex">
      <p class="my-auto text-nowrap py-2">{{ heading }}</p>
      <template v-if="inputField == true">
      <div class="input-group">
        <label id="discountCodeLabel" for="discountCode" class="sr-only">Discount Code</label>
        <input id="discountCode" :value="inputValue" @change="updateDiscount" type="text" class="form-control ms-2" :disabled="lineValue != 0 ? 'disabled' : false" placeholder="" aria-describedby="discountCodeLabel">
        <div class="input-group-append">
          <!-- <button class="btn btn-secondary" type="button" @click="addDiscount"><font-awesome-icon :icon="['fas', 'arrow-right']" /></button> -->
          <button class="btn btn-light" :class="{ 'd-none': inputValue == '' }" type="button" @click="removeDiscount"><font-awesome-icon :icon="['fas', 'xmark']" /></button>
        </div>
      </div>
      </template>
    </div>
    <p class="my-auto" :class="{ 'negative': lineValue < 0 }">{{ useFormatPrice(lineValue) }}</p>
  </div>
</template>

<script>
import { useFormatPrice } from '../helpers/formatPrice.js'

export default {
  name: 'CartFooter',
  props: {
    heading: String,
    lineValue: Number,
    inputField: Boolean,
    inputValue: String,
  },
  methods: {
    useFormatPrice: useFormatPrice,
    updateDiscount(e){
      this.$store.dispatch('addDiscountCode', {
        discountCode: e.target.value,
      })
    },
    addDiscount(){
      this.$store.dispatch('addDiscountCode', {
        discountCode: this.inputValue,
      })
    },
    removeDiscount(){
      this.$store.dispatch('removeDiscountCode', {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lineItem{
            border-top: 1px solid rgba(0,0,0,.125);
}
.shopping-cart-interior p{
            margin-bottom: 0;
            font-size: 1.2rem;
}
.shopping-cart-interior .input-group input{
            width: 5rem;
}
.negative{
            color: #ab2417 !important;
}
</style>
